import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import LoanAgreementsIndexPage from '../containers/LoanAgreements'
import { LOAN_AGREEMENT_ROLES } from '../containers/LoanAgreements/graphql'
import { withAuthorization } from '../containers/Authorization'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const LoanAgreementsIndex = withAuthorization(LoanAgreementsIndexPage, LOAN_AGREEMENT_ROLES)

const LoanAgreementsPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'loan_agreements') {
      dispatch(changeCurrent(['loan_agreements']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/:id?`} component={LoanAgreementsIndex} exact />
    </Switch>
  )
}

LoanAgreementsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

LoanAgreementsPage.defaultProps = {}

export default LoanAgreementsPage
